var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLivestream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920",
    transform: "translate(-7212 -804.262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    width: 28,
    height: 28,
    transform: "translate(7212 804.262)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M7228.524,817.5c-.02-.012-3.444-1.773-3.466-1.785a.88.88,0,0,0-1.319.762v3.569a.87.87,0,0,0,.44.762.887.887,0,0,0,.445.12.815.815,0,0,0,.413-.109l3.487-1.8a.88.88,0,0,0,0-1.523Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M7233.415,811.308a.7.7,0,0,0-.993.993,8.439,8.439,0,0,1,0,11.922.7.7,0,0,0,.993.994,9.844,9.844,0,0,0,0-13.909Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M7230.941,813.326a.7.7,0,1,0-.994.993,5.581,5.581,0,0,1,0,7.886.7.7,0,0,0,.994.993,6.987,6.987,0,0,0,0-9.872Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M7219.578,812.3a.7.7,0,1,0-.993-.993,9.844,9.844,0,0,0,0,13.909.7.7,0,0,0,.993-.994A8.439,8.439,0,0,1,7219.578,812.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M7222.053,813.326a.7.7,0,0,0-.994,0,6.987,6.987,0,0,0,0,9.872.7.7,0,0,0,.994-.993,5.581,5.581,0,0,1,0-7.886A.7.7,0,0,0,7222.053,813.326Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLivestream);
export default __webpack_public_path__ + "static/media/icon-livestream.78049c481568270668ba8c9f27ae8cea.svg";
export { ForwardRef as ReactComponent };